/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentProviders = sqliteTable('appointment_providers', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  full_name: text('full_name'),
  display_name: text('display_name'),
  specialty: text('specialty'),
  email: text('email'),
  mobile: text('mobile'),
  avatar_color: text('avatar_color'),
  active: integer('active'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
